import { render, staticRenderFns } from "./edit-custom-dropdown-items.vue?vue&type=template&id=52eb2278"
import script from "./edit-custom-dropdown-items.vue?vue&type=script&lang=js"
export * from "./edit-custom-dropdown-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports